import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BellRing } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../contexts/AuthContext';
import { Checkbox } from '../ui/checkbox';
import { API_URL, PendBadge } from './pendShared';
import { AlertComercialDialog } from './AlertComercialDialog';
import { companyLabel } from '../client360/c360Shared';

const key = (s) => s.contract_id ? `c:${s.contract_id}` : `l:${s.lead_id}`;
const canAlertFor = (uid) => (s) => s.owner_id && s.owner_id !== uid && !(s.pendencia && ['enviado', 'lido', 'em_atraso', 'pendente_resolucao'].includes(s.pendencia.status));

export const SituacoesTab = ({ onSent }) => {
  const { user } = useAuth();
  const canAlert = canAlertFor(user?.id);
  const [tipo, setTipo] = useState('mudar');
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState({});
  const [dlg, setDlg] = useState(null);
  const load = useCallback(async () => {
    try { const { data } = await axios.get(`${API_URL}/pendencias/situacoes`, { params: { tipo } }); setRows(data); setSel({}); } catch { setRows([]); }
  }, [tipo]);
  useEffect(() => { load(); }, [load]);
  const selectable = rows.filter(canAlert);
  const chosen = rows.filter((r) => sel[key(r)]);
  const allOn = selectable.length > 0 && chosen.length === selectable.length;

  return (
    <div className="space-y-3" data-testid="pend-situacoes">
      <div className="flex flex-wrap items-center gap-2">
        {[['mudar', 'Hora de mudar'], ['lead', 'Leads em aberto']].map(([k, l]) => (
          <button key={k} onClick={() => setTipo(k)} data-testid={`pend-sit-filter-${k}`}
            className={`text-sm px-3 py-1 rounded-full border transition-colors ${tipo === k ? 'bg-[#2D3E6F] text-white border-[#2D3E6F]' : 'border-slate-200 hover:border-[#4DD4E8]'}`}>{l}</button>
        ))}
        <label className="ml-2 inline-flex items-center gap-2 text-sm text-slate-600">
          <Checkbox checked={allOn} onCheckedChange={(v) => setSel(v ? Object.fromEntries(selectable.map((r) => [key(r), true])) : {})} data-testid="pend-sit-select-all" />Selecionar todos
        </label>
        <Button size="sm" disabled={!chosen.length} onClick={() => setDlg(chosen)} className="ml-auto bg-rose-600 hover:bg-rose-700 gap-1" data-testid="pend-sit-bulk-alert">
          <BellRing className="w-4 h-4" />Alertar selecionados ({chosen.length})
        </Button>
      </div>
      {rows.length === 0 && <div className="text-sm text-slate-400 py-8 text-center" data-testid="pend-sit-empty">Sem situações por tratar.</div>}
      <div className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white">
        {rows.map((r) => (
          <div key={key(r)} className="flex items-center gap-3 p-3 text-sm" data-testid={`pend-sit-row-${key(r)}`}>
            <Checkbox disabled={!canAlert(r)} checked={!!sel[key(r)]} onCheckedChange={(v) => setSel((s) => ({ ...s, [key(r)]: !!v }))} />
            <div className="flex-1 min-w-0">
              <Link to={r.nif ? `/clientes/360?nif=${encodeURIComponent(r.nif)}` : `/clientes/360?name=${encodeURIComponent(r.nome || '')}`} className="font-semibold text-slate-800 hover:underline">{r.nome}</Link>
              <span className="text-slate-500"> · {r.tipo === 'mudar' ? `${companyLabel(r.company)} · ` : ''}{r.msg}</span>
              <div className="text-xs text-slate-500">{r.comercial || <span className="text-rose-600">Sem comercial atribuído</span>}{r.owner_id && r.owner_id === user?.id ? ' (você)' : ''}</div>
            </div>
            {r.pendencia && <PendBadge status={r.pendencia.status} />}
            <Button size="sm" variant="outline" disabled={!canAlert(r)} onClick={() => setDlg([r])} data-testid={`pend-sit-alert-${key(r)}`}>Alertar</Button>
          </div>
        ))}
      </div>
      <AlertComercialDialog open={!!dlg} items={dlg || []} onClose={() => setDlg(null)} onSent={() => { load(); onSent?.(); }} />
    </div>
  );
};
